jQuery(function ($) {
	$('.categoryCarousel').each(function () {
		const $this = $(this);
		const $items = $this.find('.categoryCarousel__items');
		const $nextArrow = $this.find('.categoryCarousel__next');
		const $prevArrow = $this.find('.categoryCarousel__prev');

		$items.slick({
			autoplay: true,
			autoplaySpeed: 8000,
			slidesToShow: 5,
			infinite: true,
			slidesToScroll: 5,
			arrows: true,
			nextArrow: $nextArrow,
			prevArrow: $prevArrow,
			responsive: [
				{
					breakpoint: 830,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
						centerPadding: '5%',
					},
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
						centerPadding: '12%',
					},
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						centerPadding: '12%',
					},
				},
			],
		});
	});
});
